import React, {useState} from 'react'
import 'react-loading-skeleton/dist/skeleton.css'
import {useTheme} from '../../context/ThemeContext'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import RecentUpdatesModal from '../Modals/RecentUpdatesModal'

interface PropsTypes {
  setCheckedLastUpdate?: any
  isHomePage?:boolean
  cards?:any
  setCards?:any
}

const LastUpdate: React.FC<PropsTypes> = ({isHomePage, cards, setCards}) => {
  const {theme} = useTheme()
  const [showRecentUpdates, setShowRecentUpdates] = useState(false)

  const handleClick = () => {
    setShowRecentUpdates(true)
  }

  const handleCloseModal = () => {
    setShowRecentUpdates(false)
  }

  return (
    <>
      <h3 className={`fw-bolder my-2 text-end text-truncate d-inline-block text-primary`}>
        <span className={`d-inline-block ${theme === 'dark' ? 'white__text' : 'text-dark'}`}>
          <span className='me-2'>
            <img src={theme === 'dark' ? toAbsoluteUrl('/media/LastUpdate_white.svg') : toAbsoluteUrl('/media/LastUpdate_black.svg')} alt="Last Updated" />
          </span>
          {' '}
        </span>
        <span
          className='m-0 me-4 ms-1 text-primary'
          style={{cursor: 'pointer'}}
          onClick={handleClick}
        >
          Recent Updates
        </span>
      </h3>

      <RecentUpdatesModal
        showModal={showRecentUpdates}
        closeModal={handleCloseModal}
        cards={cards}
        setCards={setCards}
        isHomePage={isHomePage}
      />
    </>
  )
}

export default LastUpdate
